module.exports = __webpack_public_path__ + "static/img/avatar-default.3c542acd.png";